import { sanitizeCalul } from '../../helpers/number/sanitizeCalul';
import { Enum_Commande_Status } from '../../graphql/generated/graphql';
import { ID } from '../../types/typeDef';

type Pourcentage = number;

export interface ElevesCommandesStatus {
  role?: { id?: ID; name?: string };
  commandes?: {
    status: Enum_Commande_Status;
    customerContributedToTheOng?: boolean;
  }[];
}

export interface CommissionCalcul {
  taux: number;
  commission: number;
}

const PRIME_SUR_TAUX_ENGAGEMENT: Pourcentage = 2.5 / 100;
const MIN_TAUX_ENGAGEMENT: Pourcentage = 75 / 100;

export const getCommissionSurVente = (ca: number): Pourcentage => {
  if (0 <= ca && ca < 1000) return 0;
  if (1000 <= ca && ca < 2000) return 10 / 100;
  if (2000 <= ca && ca < 3000) return 12.5 / 100;
  if (3000 <= ca && ca < 4000) return 15 / 100;
  if (4000 <= ca && ca < 5000) return 17.5 / 100;
  if (5000 <= ca && ca < 10000) return 20 / 100;
  if (10000 <= ca) return 22.5 / 100;
};

export const calculTauxEngagement = (
  eleves: ElevesCommandesStatus[]
): Pourcentage => {
  if (eleves.length === 0) return 0;

  const eleveVendeur = eleves.filter(
    eleve =>
      eleve.commandes.filter(cmd => cmd.status === Enum_Commande_Status.Paye)
        .length >= 2
  );
  return eleveVendeur.length / eleves.length;
};

export const commissionCalcul = (
  caClasse: number,
  elevesCommandesStatus: ElevesCommandesStatus[]
): CommissionCalcul => {
  let taux = getCommissionSurVente(caClasse);
  if (
    calculTauxEngagement(elevesCommandesStatus) >= MIN_TAUX_ENGAGEMENT &&
    taux !== 0
  )
    taux = taux + PRIME_SUR_TAUX_ENGAGEMENT;
  return {
    taux: sanitizeCalul(taux * 100),
    commission: sanitizeCalul(taux * caClasse)
  };
};
